import { request } from '@/utils/request'


export function studyPaperDelete( params ) {
  return request({
    url: '/base/studyPaper/delete',
    method: 'delete',
    headers: {
      'Device-Type': 'app'
    },
    params
  })
}
// 重置答题列表
export function studyRecordRenew( data ) {
  return request({
    url: '/base/studyRecord/renew',
    method: 'post',
    headers: {
      'Device-Type': 'app'
    },
    data
  })
}
export function getTree(token,params) {
  return request({
    url: '/base/studyRecord/getByStudyCategory',
    method: 'get',
    params,
    headers: {
      'Authorization':  `Bearer ${token}`,
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

export function getResourceCategory(token,params) {
  return request({
    url: '/base/studyRecord/getResourceCategory',
    method: 'get',
    params,
    headers: {
      'Authorization':  `Bearer ${token}`,
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

export function getWrongAnswerCategory(token,params) {
  return request({
    url: '/base/studyRecord/getWrongAnswerCategory',
    method: 'get',
    params,
    headers: {
      'Authorization':  `Bearer ${token}`,
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app' 
    }
  })
}

// 刷题答题卡
export function answerSheet(data) {
  return request({
    url: `/base/studyRecord/answerSheet`,
    method: 'post',
    data,
    headers: {
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 错题答题卡
export function wrongAnswerSheett(data) {
  return request({
    url: `/base/studyRecord/wrongAnswerSheet`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 收藏答题卡
export function resourceAnswerSheet(data) {
  return request({
    url: `/base/studyRecord/resourceAnswerSheet`,
    method: 'post',
    data,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}


// 刷题的题目
export function getQuestions(data) {
  return request({
    url: '/base/studyQuestionRecord/getPracticeQuestions',
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

export function getSkillCenterQuestionPage(params) {
  return request({
    url: '/base/organ/skillCenter/category/question/page',
    method: 'get',
    params,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心重置当前用户指定题目的答题记录
export function resetQuestionRecords(data) {
  return request({
    url: '/base/organ/skillCenter/category/question/reset',
    method: 'post',
    data,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心门户完整目录树
export function getSkillCenterFullTree() {
  return request({
    url: '/base/organ/skillCenter/category/fullTree',
    method: 'get',
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心智能组题可选题目数量
export function getSkillCenterGroupQuestionCount(params) {
  return request({
    url: '/base/organ/skillCenter/category/question/group/count',
    method: 'get',
    params,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心当前考站下的错题分页
export function getSkillCenterWrongQuestionPage(params) {
  return request({
    url: '/base/organ/skillCenter/category/question/wrong/page',
    method: 'get',
    params,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心当前考站下的收藏或笔记分页
export function getSkillCenterResourceQuestionPage(params) {
  return request({
    url: '/base/organ/skillCenter/category/question/resource/page',
    method: 'get',
    params,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心个人学习记录（训练、考试、题库目录学习、自主刷题）
export function getSkillCenterLearningRecordList(params) {
  return request({
    url: '/base/skill/learningRecord/list',
    method: 'get',
    params,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心学习记录详情
export function getSkillCenterLearningRecordDetail(sourceType, recordId) {
  return request({
    url: `/base/skill/learningRecord/${sourceType}/${recordId}`,
    method: 'get',
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 技能中心当前用户训练记录（与 PC 端一致）
export function getSkillCenterPracticeRecordList(params) {
  return request({
    url: '/base/practiceRecord/page',
    method: 'get',
    params,
    headers: {
      'Device-Type': 'app'
    }
  })
}

// 错题的题目
export function getWrongAnswerQuestions(data) {
  return request({
    url: '/base/studyQuestionRecord/getWrongAnswerQuestions',
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 答题
export function addQuestion(data) {
  return request({
    url: '/base/studyRecord/add',
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 作业题目作答记录（仅作业模式调用，普通刷题流程不受影响）
export function saveSkillHomeworkAnswer(data) {
  return request({
    url: '/base/skillHomework/my/answer',
    method: 'post',
    data,
    headers: {
      'Device-Type': 'app'
    }
  })
}

export function getSkillHomeworkAnswers(homeworkContentId) {
  return request({
    url: `/base/skillHomework/my/answers/${homeworkContentId}`,
    method: 'get',
    headers: {
      'Device-Type': 'app'
    }
  })
}

export function resetSkillHomeworkContent(homeworkContentId) {
  return request({
    url: `/base/skillHomework/my/content/reset/${homeworkContentId}`,
    method: 'post',
    headers: {
      'Device-Type': 'app'
    }
  })
}
// 组卷答题
export function addQuestionResult(data) {
  return request({
    url: `/base/studyPaper/questionResult/add`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 新增学习笔记
export function addQuestionResource(data) {
  return request({
    url: `/base/questionResource/add`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 查询收藏-笔记题目
export function getQuestionsList(data) {
  return request({
    url: `/base/studyQuestionRecord/getResourceQuestions`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 查询全部学习笔记
export function questionResourceList(params) {
  return request({
    url: `/base/questionResource/list`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 智能组题表
export function studyPaperPage(params) {
  return request({
    url: `/base/studyPaper/page`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 查询符合条件的题目数量
export function getNum(params) {
  return request({
    url: `/base/studyPaper/getQuestionNum`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 新增智能组题
export function addAnswer(data) {
  return request({
    url: `/base/studyPaper/add`,
    method: 'post',
    data,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}


// 智能组题答题卡
export function combinationAnswerSheet(studyPaperId) {
  return request({
    url: `/base/studyPaper/answerSheet/${studyPaperId}`,
    method: 'get',
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 根据id查询智能组题表
export function studyPaperGetById(studyPaperId,params) {
  return request({
    url: `/base/studyPaper/getById/${studyPaperId}`,
    method: 'get',
    params,
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 获取问题详情
export function getOneQuestionId(majorType,questionId) {
  return request({
    url: `/base/studyQuestionRecord/getOnePracticeQuestion/${majorType}/${questionId}`,
    method: 'get',
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 商品基本信息
export function getById(id) {
  return request({
    url: `/base/product/info/getById/${id}`,
    method: 'get',
    headers: {
         //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}

// 查询考试题库类型列表
export function tbQuestionMajorTypeList(token,params) {
  return request({
    url: `/base/tbQuestionMajorType/list`,
    method: 'get',
    params,
    headers: {
      'Authorization':  `Bearer ${token}`,
      'Device-Type': 'app' 
    }
  })
}

//提交纠错
export function questionFeedBackErrorAdd(data) {
  return request({
    url: `/exam/questionFeedBack/add`,
    method: 'post',
    data,
    headers: {
      //'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjoyLCJ1c2VyX2lkIjo0MDgwNywib3JnX2lkIjowLCJ1c2VyX2tleSI6ImU0YzBkNGFiLTI1NjctNGFmMC05MGFmLWMyMGNlOGMwZTY3YiIsImRldmljZV90eXBlIjoiQWRtaW4iLCJ1c2VybmFtZSI6IjEzMTY0MTg3MTkzIn0.2kCioFakfBqlrhGTyWzQC8ObXnD38e7KC7QP10pjWN3GYzs5mmkb-Rm92lNC28PMOiQM5gnUbMV_TrNCY-o8Tg`,
      'Device-Type': 'app'
    }
  })
}
